import type { TicketStatus } from '../lib/api';
import { STATUS_LABELS } from '../lib/api';

const colorMap: Record<TicketStatus, string> = {
  open: 'bg-status-open/10 text-status-open',
  in_progress: 'bg-status-progress/10 text-status-progress',
  waiting_user: 'bg-status-waiting/10 text-status-waiting',
  resolved: 'bg-status-resolved/10 text-status-resolved',
  archived: 'bg-status-archived/10 text-status-archived',
};

export function StatusPill({ status }: { status: TicketStatus }) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-[12px] font-medium ${colorMap[status]}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {STATUS_LABELS[status]}
    </span>
  );
}
